<template>
<div class="tgh-collaborators tgh-page">
  <TitlePage title="COMMERCIAL" :desc="summary"></TitlePage>
  <div class="tgh-collaborators-box">
    <div class="row no-gutters" v-if="collabList.length > 0">
      <b-carousel id="collab-carousel" :interval="4000" indicators class="w-100 p-0">
        <b-carousel-slide v-for="(colab,colabIndex) in collabList" :key="`colab-item-${colabIndex}`" img-blank>
          <router-link :to="`/commercial/${encodeURI(colab.id)}`">
            <img class="d-block img-fluid w-100" :src="colab.photo" alt="image slot">
            <h1>{{colab.title}}</h1>
          </router-link>
        </b-carousel-slide>
      </b-carousel>
      <!-- <div :class="`col-12 ${colheight} col-md-${colSize}`" v-for="(colab,colabIndex) in collabList" :key="`colab-item-${colabIndex}`" :style="(colab.photo_available) ? `background:url('${colab.photo}') no-repeat;` : '-webkit-filter: grayscale(0);filter: grayscale(0);'" style="background-position:center center;background-size:cover">
        <router-link :to="`/collaborators/${colab.title}`">
          <h1>{{ colab.title }}</h1>
          <span v-if="colab.subtitle">({{ colab.subtitle }})</span>
        </router-link>
      </div> -->
    </div>
  </div>
  <div class="tgh-blank" v-if="collabList.length < 1"></div>
  <AddressNav></AddressNav>
</div>
</template>

<script>
import {
  apiUrl
} from '../config'
import axios from 'axios'
import AddressNav from '@/components/AddressNav.vue'
import TitlePage from '@/components/TitlePage.vue'
export default {
  name: 'Commercial',
  components: {
    AddressNav,
    TitlePage
  },

  data() {
    return {
      collabList: [],
      colSize: 6,
      colheight: '',
      summary: []
    }
  },
  methods: {
    getData() {
      let vm = this
      let url = apiUrl + '/commercial?sort=id&page=1&per_page=100'
      axios.get(
          url
        )
        .then(response => {
          if (response.data.status) {
            vm.collabList = response.data.data
            switch (vm.collabList.length) {
              case 1:
                vm.colSize = 12
                vm.colheight = 'height-full'
                break;
              case 2:
                vm.colSize = 6
                vm.colheight = 'height-full'
                break;
              case 3:
                vm.colSize = 4
                vm.colheight = 'height-full'
                break;
              case 4:
                vm.colSize = 6
                break;
            }
          }
        })
        .catch(e => {
          console.log('Internal server error')
        })
    },
    getSummary() {
      let vm = this
      let url = apiUrl + '/home/summary'
      axios.get(
          url
        )
        .then(response => {
          if (response.data.status) {
            vm.summary = response.data.data.collaborator
          }
        })
        .catch(e => {
          console.log('Internal server error')
        })
    }
  },
  mounted() {
    this.getData()
    this.getSummary()
  }
}
</script>
